module.exports = __webpack_public_path__ + "img/mb-eduDP.ad1a30b3.svg";